import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.6 10.23c.1 1.83 1.59 3.27 3.4 3.27h.01c1.8 0 3.3-1.44 3.4-3.27l.1-1.74c0-1.93-1.54-3.49-3.43-3.49h-.15c-1.88 0-3.42 1.56-3.42 3.54zm1.9-1.74c0-.82.64-1.49 1.43-1.49h.14c.79 0 1.43.67 1.43 1.43l-.09 1.69c-.04.77-.66 1.38-1.41 1.38s-1.37-.6-1.41-1.38z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8 0 1.582.462 3.06 1.259 4.303C5.98 14.946 7.563 14 9.4 14h5.2c1.83 0 3.416.946 4.14 2.304A7.95 7.95 0 0 0 20 12c0-4.41-3.59-8-8-8m0 16a7.97 7.97 0 0 1-5.17-1.9 1 1 0 0 0 .01-.14C6.84 16.88 7.99 16 9.4 16h5.2c1.41 0 2.56.88 2.56 1.96q0 .07.01.14A7.97 7.97 0 0 1 12 20"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonInCircle;
